import { AppConst } from 'constants/appConst';
import { formatTimeToDate } from 'utils/app';

import type { JSX } from 'react';

export interface WsIndexPlanBannerProps {
  isTrial: boolean;
  isExpiredPlan: boolean;
  planEndAt: number;
}

/**
 * ホーム画面 プランバナーコンポーネント（トライアル / 期限切れ）
 */
export default function WsIndexPlanBanner({
  isTrial,
  isExpiredPlan,
  planEndAt,
}: WsIndexPlanBannerProps): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  if (isTrial) {
    return (
      <div className="container">
        <div className="card-white card-body mb-3 p-3">
          <div className="d-block mb-2 lh-lg">
            トライアルプラン利用中です。 利用期限：
            {formatTimeToDate(planEndAt, 'yyyy/MM/dd HH:mm')}
          </div>
          <div className="d-block lh-lg">
            <a href={AppConst.url.upgrade} className="btn btn-progress mx-auto me-1">
              お問い合わせフォーム
            </a>
            <span className="my-0">
              よりスタンダードプランへの変更を行うことで全機能をご利用いただけます。
            </span>
          </div>
        </div>
      </div>
    );
  }

  if (isExpiredPlan) {
    return (
      <div className="container">
        <div className="card-white card-body mb-3 p-3 text-bg-danger">
          <div className="d-block mb-2 lh-lg">
            プランの利用期間が終了したため一部機能が制限されています。
          </div>
          <div className="d-block lh-lg">
            <a href={AppConst.url.upgrade} className="btn btn-progress mx-auto me-1">
              お問い合わせフォーム
            </a>
            <span className="my-0">
              よりスタンダードプランへの変更を行うことで全機能をご利用いただけます。
            </span>
          </div>
        </div>
      </div>
    );
  }

  return <></>;
}
